import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    selector: 'app-checkbox-input',
    template: `
        <div [formGroup]="parentFormGroup">
            <mat-checkbox [formControlName]="parentFormControlName" (change)="change($event)"><span class="text">{{label}}</span></mat-checkbox>
        </div>
    `,
    styles: [`
        :host ::ng-deep .mat-mdc-checkbox .mdc-checkbox {
            transform: scale(0.7);
            transform-origin: center left;
        }

        :host ::ng-deep .mat-mdc-checkbox {
            padding: 0 !important;
        }
    `]
})
export class CheckboxInputComponent {
    @Input() label: string;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Output() changeEvent = new EventEmitter<boolean>();

    change(event: MatCheckboxChange) {
        if (this.changeEvent) {
            this.changeEvent.emit(event.checked);
        }
    }
}
